/* D'ORVÉN cart drawer — "Pit lane" */
(function () {
  if (window.DorvenCart && window.DorvenCart.open) return;
  var root, panel, cfg = {}, cart = null, lastFocus = null, busy = false, cleaning = false;
  var eng = { key: null, pos: 'Crown', initial: '', name: '' }, viewer = null, load3d = false;

  function $(sel) { return root.querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/'; }
  function shortName(t) { return String(t || '').split(' — ')[0]; }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function isEng(it) { return cfg.engrave && String(it.product_id) === String(cfg.engrave.product_id); }
  function isWatch(it) { return (cfg.watches || []).map(String).indexOf(String(it.product_id)) > -1; }
  function finishOf(it) { return it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''; }
  function prop(it, k) { return it.properties && it.properties[k] != null ? String(it.properties[k]) : ''; }
  var CASE_MAX = 12;
  function engText(it) { return [prop(it, 'Initial'), prop(it, 'Name') || prop(it, 'Initials')].filter(Boolean).join(' · '); }
  function clean(v, pos) {
    if (pos === 'Crown') return v.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 1);
    return v.toUpperCase().replace(/[^A-ZÀ-ÖØ-Ý' -]/g, '').replace(/\s{2,}/g, ' ').replace(/^\s+/, '').slice(0, CASE_MAX);
  }

  function loading(on) { var l = $('[data-dv-cart-loading]'); if (l) l.hidden = !on; root.classList.toggle('is-busy', !!on); busy = !!on; }

  function request(path, body) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(base() + path, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function refresh() { return request('cart.js').then(function (c) { cart = c; render(); return c; }); }

  function updateCounts() {
    var n = cart ? cart.item_count : 0;
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    var c = $('[data-dv-cart-count]'); if (c) { c.textContent = n || ''; c.hidden = !n; }
  }

  /* ---------- line items ---------- */
  function priceHtml(it) {
    var free = it.final_line_price === 0 && it.original_line_price > 0;
    if (free) return '<span class="dv-ci__free">Free</span><s>' + money(it.original_line_price) + '</s>';
    if (it.final_line_price < it.original_line_price) return '<span class="is-now">' + money(it.final_line_price) + '</span><s>' + money(it.original_line_price) + '</s>';
    return '<span class="is-now">' + money(it.final_line_price) + '</span>';
  }
  function engLine(it) {
    return '<li class="dv-ce" data-key="' + esc(it.key) + '">' +
      '<span class="dv-ce__ico" aria-hidden="true">' + esc(engText(it).charAt(0) || '·') + '</span>' +
      '<span class="dv-ce__txt"><b>Engraving · ' + esc(prop(it, 'Engraving')) + '</b><small>“' + esc(engText(it)) + '” on ' + esc(prop(it, 'Watch') || 'your watch') + '</small></span>' +
      '<span class="dv-ce__price">' + money(it.final_line_price) + '</span>' +
      '<button type="button" class="dv-ce__x" data-dv-remove aria-label="Remove engraving"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
    '</li>';
  }
  function watchLine(it, i) {
    var free = it.final_line_price === 0 && it.original_line_price > 0;
    var disc = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean)[0];
    var finish = finishOf(it);
    return '<li class="dv-ci' + (free ? ' is-free' : '') + '" data-key="' + esc(it.key) + '" style="--i:' + i + '">' +
      '<a class="dv-ci__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="" width="96" height="96" loading="lazy" style="opacity:1;visibility:visible">' : '') +
        '<span class="dv-ci__pos">P' + (i + 1) + '</span></a>' +
      '<div class="dv-ci__info">' +
        '<div class="dv-ci__top"><a class="dv-ci__name" href="' + esc(it.url) + '">' + esc(shortName(it.product_title)) + '</a>' +
        '<div class="dv-ci__price">' + priceHtml(it) + '</div></div>' +
        (finish ? '<p class="dv-ci__finish">' + esc(finish) + '</p>' : '') +
        (disc ? '<p class="dv-ci__disc">' + esc(disc) + '</p>' : '') +
        '<div class="dv-ci__row">' +
          '<div class="dv-ci__qty" role="group" aria-label="Quantity">' +
            '<button type="button" data-dv-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-dv-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="dv-ci__remove" data-dv-remove>Remove</button>' +
        '</div>' +
      '</div></li>';
  }

  function render() {
    if (!cart) return;
    updateCounts();
    var items = cart.items || [];
    var list = $('[data-dv-cart-items]');
    var empty = items.length === 0;
    $('[data-dv-cart-empty]').hidden = !empty;
    $('[data-dv-cart-foot]').hidden = empty;
    root.classList.toggle('is-empty', empty);

    var engs = items.filter(isEng), others = items.filter(function (it) { return !isEng(it); });
    var plan = assign(items), used = {};
    var html = others.map(function (it, i) {
      var h = watchLine(it, i);
      (plan.byLine[it.key] || []).forEach(function (e) { h += engLine(e); used[e.key] = 1; });
      return h;
    }).join('');
    var orphans = engs.filter(function (e) { return !used[e.key]; });
    list.innerHTML = html + orphans.map(engLine).join('');

    /* an engraving without its watch is removed automatically */
    if (orphans.length && !cleaning) {
      cleaning = true;
      var upd = {}; orphans.forEach(function (o) { upd[o.key] = 0; });
      request('cart/update.js', { updates: upd }).then(function (c) { cart = c; cleaning = false; render(); }).catch(function () { cleaning = false; });
    }

    /* Totals */
    $('[data-dv-cart-subtotal]').textContent = money(cart.original_total_price);
    var discWrap = $('[data-dv-cart-discounts]');
    var groups = {};
    items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (d) {
        var t = (d.discount_application && d.discount_application.title) || 'Discount';
        groups[t] = (groups[t] || 0) + d.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { groups[d.title || 'Discount'] = (groups[d.title || 'Discount'] || 0) + d.total_allocated_amount; });
    var itemSavings = items.reduce(function (s, it) { return s + Math.max(0, it.original_line_price - it.final_line_price); }, 0);
    if (itemSavings > 0 && Object.keys(groups).length === 0) groups['Savings'] = itemSavings;
    discWrap.innerHTML = Object.keys(groups).map(function (t) { return '<div><dt>' + esc(t) + '</dt><dd class="is-save">&minus;' + money(groups[t]) + '</dd></div>'; }).join('');
    $('[data-dv-cart-total]').textContent = money(cart.total_price);

    renderOffer(items);
    renderEngrave(items);
    renderBumps(items);
  }

  /* ---------- Buy 1, Get 1 Free meter ---------- */
  function renderOffer(items) {
    var box = $('[data-dv-cart-offer]');
    if (!box) return;
    var count = items.reduce(function (n, it) { return n + (isWatch(it) ? it.quantity : 0); }, 0);
    var applied = items.some(function (it) { return isWatch(it) && it.final_line_price < it.original_line_price; });
    if (!count) { box.hidden = true; return; }
    var pct = applied || count >= 2 ? 100 : 50;
    var msg, cta = '';
    if (applied) {
      var saved = items.reduce(function (s, it) { return s + (it.original_line_price - it.final_line_price); }, 0);
      msg = '<span class="dv-meter__save">You save <b>' + money(saved) + '</b></span>';
    } else {
      msg = '<b>1 of 2</b> <span>' + esc(cfg.offerNudge) + '</span>';
      cta = '<a href="' + esc(cfg.offerLink) + '" class="dv-meter__cta">Pick #2 <i aria-hidden="true">&rarr;</i></a>';
    }
    box.innerHTML =
      '<div class="dv-meter' + (pct === 100 ? ' is-full' : '') + '">' +
        '<div class="dv-meter__row"><span class="dv-meter__tag">' + (applied ? '<i aria-hidden="true">&#10003;</i> Buy 1 · Get 1 Free applied' : 'Buy 1 · Get 1 Free') + '</span><span class="dv-meter__msg">' + msg + '</span>' + cta + '</div>' +
        '<div class="dv-meter__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="--p:' + pct + '%"></span><i></i><i></i></div>' +
        '<div class="dv-meter__ticks" aria-hidden="true"><span>Watch 1</span><span>Watch 2 · Free</span></div>' +
      '</div>';
    box.className = 'dv-cart__offer' + (pct === 100 ? ' is-applied' : '');
    box.hidden = false;
  }

  /* ---------- Personal engraving bump ---------- */
  /* engravings are matched to watch units of the same variant, in bag order */
  function assign(items) {
    var byLine = {}, free = {};
    var watches = items.filter(isWatch);
    var cap = {}; watches.forEach(function (w) { cap[w.key] = w.quantity; byLine[w.key] = []; });
    items.filter(isEng).forEach(function (e) {
      for (var n = 0; n < e.quantity; n++) {
        var host = watches.filter(function (w) { return String(w.variant_id) === prop(e, '_for_variant') && cap[w.key] > 0; })[0];
        if (!host) return;
        cap[host.key]--; if (byLine[host.key].indexOf(e) === -1) byLine[host.key].push(e);
      }
    });
    watches.forEach(function (w) { free[w.key] = cap[w.key]; });
    return { byLine: byLine, free: free };
  }
  function eligibleWatches(items) {
    var plan = assign(items);
    return items.filter(function (it) { return isWatch(it) && plan.free[it.key] > 0; });
  }

  function renderEngrave(items) {
    var box = $('[data-dv-eng]');
    if (!box || !cfg.engrave) return;
    var list = eligibleWatches(items);
    if (!list.length) { box.hidden = true; return; }
    box.hidden = false;
    if (!list.some(function (w) { return w.key === eng.key; })) eng.key = list[0].key;
    var wrap = $('[data-dv-eng-watches]');
    $('[data-dv-eng-watchwrap]').hidden = list.length < 2;
    var order = (cart.items || []).filter(function (it) { return !isEng(it); }).map(function (it) { return it.key; });
    wrap.innerHTML = list.map(function (w) {
      var on = w.key === eng.key;
      var pos = 'P' + (order.indexOf(w.key) + 1) + ' · ';
      return '<button type="button" role="radio" aria-checked="' + on + '" class="dv-eng__w' + (on ? ' is-on' : '') + '" data-dv-eng-watch="' + esc(w.key) + '">' +
        (w.image ? '<img src="' + esc(img(w.image, 120)) + '" alt="" width="40" height="40" style="opacity:1;visibility:visible">' : '') +
        '<span>' + pos + esc(shortName(w.product_title)) + '</span></button>';
    }).join('');
    drawPreview();
  }

  function currentWatch() { return (cart.items || []).filter(function (it) { return it.key === eng.key; })[0]; }

  function svgText(txt, x, y, size, extra) {
    var t = esc(txt);
    return '<text x="' + x + '" y="' + (y + 1.6) + '" font-size="' + size + '" fill="rgba(255,255,255,.55)" ' + extra + '>' + t + '</text>' +
           '<text x="' + x + '" y="' + y + '" font-size="' + size + '" fill="url(#dvEngCut)" ' + extra + '>' + t + '</text>';
  }
  var FAM = "font-family=\"'Cinzel','Trajan Pro',Georgia,serif\" font-weight=\"600\" text-anchor=\"middle\" dominant-baseline=\"central\"";
  var DEFS =
    '<defs>' +
      '<radialGradient id="dvEngMetal" cx="38%" cy="32%" r="80%"><stop offset="0" stop-color="#f4f4f6"/><stop offset=".45" stop-color="#b9bbc1"/><stop offset=".8" stop-color="#7b7e86"/><stop offset="1" stop-color="#4b4d53"/></radialGradient>' +
      '<linearGradient id="dvEngCut" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1b1c20"/><stop offset="1" stop-color="#4a4c52"/></linearGradient>' +
      '<pattern id="dvEngBrush" width="4" height="4" patternUnits="userSpaceOnUse"><path d="M0 2h4" stroke="rgba(255,255,255,.07)" stroke-width=".6"/></pattern>' +
      '<radialGradient id="dvEngGlow" cx="50%" cy="50%" r="50%"><stop offset="0" stop-color="#E10600" stop-opacity=".55"/><stop offset="1" stop-color="#E10600" stop-opacity="0"/></radialGradient>' +
    '</defs>';
  /* crown drawn around (150,110), radius 100 */
  function crownArt(letter, ghost) {
    var teeth = '';
    for (var k = 0; k < 48; k++) { var a = k / 48 * Math.PI * 2; teeth += '<line x1="' + (150 + Math.cos(a) * 92).toFixed(1) + '" y1="' + (110 + Math.sin(a) * 92).toFixed(1) + '" x2="' + (150 + Math.cos(a) * 100).toFixed(1) + '" y2="' + (110 + Math.sin(a) * 100).toFixed(1) + '" stroke="#2c2d31" stroke-width="3"/>'; }
    return '<circle cx="150" cy="110" r="108" fill="url(#dvEngGlow)"/>' +
      '<circle cx="150" cy="110" r="100" fill="#8d9097"/>' + teeth +
      '<circle cx="150" cy="110" r="88" fill="url(#dvEngMetal)" stroke="#3a3b40" stroke-width="2"/>' +
      '<circle cx="150" cy="110" r="88" fill="url(#dvEngBrush)"/>' +
      '<circle cx="150" cy="110" r="74" fill="none" stroke="rgba(0,0,0,.25)" stroke-width="1"/>' +
      '<g opacity="' + (ghost ? '.35' : '1') + '">' + svgText(letter, 150, 112, 92, FAM) + '</g>';
  }
  /* caseback drawn in the 300x220 box */
  function caseArt(name, ghost) {
    var size = Math.max(16, Math.min(46, Math.floor(158 / (name.length * 0.8))));
    var shape = 'M150 18 C200 18 228 28 232 64 C236 100 236 120 232 156 C228 192 200 202 150 202 C100 202 72 192 68 156 C64 120 64 100 68 64 C72 28 100 18 150 18Z';
    return '<ellipse cx="150" cy="110" rx="140" ry="110" fill="url(#dvEngGlow)"/>' +
      '<path d="M150 8 C206 8 238 20 242 60 C247 100 247 120 242 160 C238 200 206 212 150 212 C94 212 62 200 58 160 C53 120 53 100 58 60 C62 20 94 8 150 8Z" fill="#55575d"/>' +
      '<path d="' + shape + '" fill="url(#dvEngMetal)" stroke="#2f3035" stroke-width="2"/>' +
      '<path d="' + shape + '" fill="url(#dvEngBrush)"/>' +
      [[84, 40], [216, 40], [84, 180], [216, 180]].map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="5" fill="#6d7077" stroke="#2c2d31"/><path d="M' + (p[0] - 3) + ' ' + p[1] + 'h6" stroke="#2c2d31" stroke-width="1.4"/>'; }).join('') +
      '<g opacity="' + (ghost ? '.35' : '1') + '">' + svgText(name, 150, 104, size, FAM + ' letter-spacing="1.5"') + '</g>' +
      svgText("D’ORVÉN", 150, 160, 13, FAM + ' letter-spacing="3"');
  }

  function needs(pos) { return { crown: pos !== 'Caseback', name: pos !== 'Crown' }; }
  function ready() {
    var n = needs(eng.pos);
    return (!n.crown || !!eng.initial) && (!n.name || !!eng.name.trim());
  }

  function drawPreview() {
    var stage = $('[data-dv-eng-stage]');
    if (!stage) return;
    var w = currentWatch();
    var letter = eng.initial || 'A', name = eng.name.trim() || 'SILVA';
    var svg, cap;
    if (eng.pos === 'Crown') { svg = crownArt(letter, !eng.initial); cap = 'Crown · enlarged view'; }
    else if (eng.pos === 'Caseback') { svg = caseArt(name, !eng.name.trim()); cap = 'Caseback'; }
    else {
      svg = '<g transform="translate(-34 16) scale(.86)">' + caseArt(name, !eng.name.trim()) + '</g>' +
            '<path d="M196 110h18" stroke="#3A3A3F" stroke-width="1" stroke-dasharray="3 3"/>' +
            '<g transform="translate(250 110) scale(.32)"><g transform="translate(-150 -110)">' + crownArt(letter, !eng.initial) + '</g></g>' +
            '<text x="250" y="156" font-size="9" fill="#8E8E94" text-anchor="middle" font-family="JetBrains Mono, monospace" letter-spacing="1.5">CROWN</text>';
      cap = 'Caseback + crown (enlarged)';
    }
    var capHtml = cap + (w ? ' — ' + esc(shortName(w.product_title)) : '');
    var E3 = window.DorvenEngrave3D;
    if (w && E3 && E3.supported && window.THREE && E3.has(w.variant_id)) {
      if (!viewer || viewer.vid !== w.variant_id || !stage.contains(viewer.el)) {
        if (viewer) viewer.api.destroy();
        stage.innerHTML = '<span class="dv-eng__cap" data-dv-eng-cap></span><span class="dv-eng__hint" aria-hidden="true">Drag to rotate</span>';
        var api = E3.mount(stage, w.variant_id);
        viewer = api ? { api: api, vid: w.variant_id, el: stage.querySelector('canvas') } : null;
      }
      if (viewer) {
        viewer.api.update({ pos: eng.pos, initial: eng.initial, name: eng.name });
        stage.classList.add('is-3d');
        var c3 = stage.querySelector('[data-dv-eng-cap]'); if (c3) c3.innerHTML = (eng.pos === 'Crown' ? 'Crown' : eng.pos === 'Caseback' ? 'Caseback' : 'Crown + caseback') + (w ? ' — ' + esc(shortName(w.product_title)) : '');
      }
    } else {
      if (viewer) { viewer.api.destroy(); viewer = null; }
      stage.classList.remove('is-3d');
      stage.innerHTML = '<svg viewBox="0 0 300 220" role="img">' + DEFS + svg + '</svg>' +
        '<span class="dv-eng__cap">' + capHtml + '</span>';
      if (w && E3 === undefined && cfg.engrave3d && !load3d) {
        load3d = true;
        var sc = document.createElement('script'); sc.src = cfg.engrave3d; sc.async = true;
        sc.onload = function () { if (window.DorvenEngrave3D && DorvenEngrave3D.supported) DorvenEngrave3D.ready().then(drawPreview, function () {}); };
        document.head.appendChild(sc);
      }
    }
    var btn = $('[data-dv-eng-add]');
    if (btn) btn.disabled = !ready();
    var v = cfg.engrave && cfg.engrave.variants && cfg.engrave.variants[eng.pos];
    var pr = $('[data-dv-eng-addprice]'); if (pr && v) pr.textContent = '+' + money(v.cents);
  }

  function setPos(pos) {
    eng.pos = pos;
    root.querySelectorAll('[data-dv-eng-pos]').forEach(function (b) { var on = b.getAttribute('data-dv-eng-pos') === pos; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
    var n = needs(pos);
    $('[data-dv-eng-f="crown"]').hidden = !n.crown;
    $('[data-dv-eng-f="name"]').hidden = !n.name;
    drawPreview();
  }

  function count() { var c = $('[data-dv-eng-count]'); if (c) c.textContent = eng.name.length + '/' + CASE_MAX; }

  function addEngraving() {
    var w = currentWatch();
    eng.name = eng.name.trim();
    var v = cfg.engrave && cfg.engrave.variants && cfg.engrave.variants[eng.pos];
    if (!w || !v || !ready()) return;
    var label = $('[data-dv-eng-addlabel]');
    var finish = finishOf(w), n = needs(eng.pos);
    var props = { 'Engraving': eng.pos === 'Both' ? 'Crown + Caseback' : eng.pos };
    if (n.crown) props['Initial'] = eng.initial;
    if (n.name) props['Name'] = eng.name;
    props['Watch'] = shortName(w.product_title) + (finish ? ' (' + finish + ')' : '');
    props['_for_variant'] = String(w.variant_id);
    label.textContent = 'Engraving…';
    add([{ id: v.id, quantity: 1, properties: props }]).then(function () {
      eng.initial = ''; eng.name = '';
      root.querySelectorAll('[data-dv-eng-initial],[data-dv-eng-name]').forEach(function (i) { i.value = ''; });
      count();
      var t = $('[data-dv-eng-toggle]'); if (t) { t.checked = false; $('[data-dv-eng-body]').hidden = true; $('[data-dv-eng]').classList.remove('is-open'); }
      label.textContent = 'Add engraving';
      drawPreview();
    }, function () { label.textContent = 'Add engraving'; });
  }

  /* ---------- product bumps ---------- */
  function renderBumps(items) {
    var wrap = $('[data-dv-cart-bumps]'), list = $('[data-dv-cart-bump-list]');
    if (!wrap || !list) return;
    var inCart = items.map(function (it) { return String(it.product_id); });
    var bumps = (cfg.bumps || []).filter(function (b) { return inCart.indexOf(String(b.product_id)) === -1; });
    if (!items.length || !bumps.length) { wrap.hidden = true; list.innerHTML = ''; return; }
    wrap.hidden = false;
    list.innerHTML = bumps.map(function (b) {
      return '<li class="dv-bump">' +
        '<a class="dv-bump__img" href="' + esc(b.url) + '">' + (b.image ? '<img src="' + esc(b.image) + '" alt="" width="64" height="64" loading="lazy" style="opacity:1;visibility:visible">' : '') + '</a>' +
        '<div class="dv-bump__info"><p class="dv-bump__name">' + esc(b.title) + '</p>' +
          (b.text ? '<p class="dv-bump__text">' + esc(b.text) + '</p>' : '') +
          '<p class="dv-bump__price"><span>' + money(b.cents) + '</span>' + (b.compare > b.cents ? '<s>' + money(b.compare) + '</s>' : '') + '</p></div>' +
        '<button type="button" class="dv-bump__add" data-dv-bump="' + b.variant_id + '">Add</button>' +
      '</li>';
    }).join('');
  }

  /* ---------- cart actions ---------- */
  function change(key, qty) {
    if (busy) return;
    loading(true);
    request('cart/change.js', { id: key, quantity: qty })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) { flash((e && (e.description || e.message)) || 'Could not update your bag.'); })
      .then(function () { loading(false); });
  }

  function add(items) {
    loading(true);
    return request('cart/add.js', { items: items })
      .then(refresh)
      .catch(function (e) { flash((e && (e.description || e.message)) || 'Could not add to bag.'); throw e; })
      .then(function (c) { loading(false); return c; }, function (e) { loading(false); throw e; });
  }

  function flash(msg) {
    var p = $('.dv-cart__msg');
    if (!p) { p = document.createElement('p'); p.className = 'dv-cart__msg'; p.setAttribute('role', 'alert'); $('[data-dv-cart-body]').prepend(p); }
    p.textContent = msg;
    clearTimeout(p._t); p._t = setTimeout(function () { p.remove(); }, 5000);
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dv-cart-lock');
    setTimeout(function () { var x = root.querySelector('.dv-cart__x'); if (x) x.focus(); }, 60);
    refresh();
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dv-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function isCartLink(a) {
    if (!a) return false;
    if (a.classList && a.classList.contains('cart-drawer-button')) return true;
    var href = a.getAttribute && a.getAttribute('href');
    if (!href) return false;
    var cartPath = base() + 'cart';
    return href === '/cart' || href === cartPath || /\/cart\/?$/.test(href.split('?')[0]);
  }

  function init() {
    root = document.querySelector('[data-dv-cart]');
    if (!root || root.dataset.dvReady) return;
    root.dataset.dvReady = '1';
    panel = root.querySelector('.dv-cart__panel');
    try { cfg = JSON.parse(root.querySelector('[data-dv-cart-config]').textContent); } catch (e) { cfg = {}; }

    /* Intercept every cart link (header icon, mobile dock) before the theme sees it */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a, button.cart-drawer-button');
      if (!a || !isCartLink(a) || root.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (/\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open();
    }, true);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-dv-cart-close]')) { close(); return; }
      var li = e.target.closest('.dv-ci, .dv-ce');
      var q = e.target.closest('[data-dv-qty]');
      if (q && li) {
        var current = parseInt(li.querySelector('.dv-ci__qty span').textContent, 10) || 1;
        change(li.getAttribute('data-key'), Math.max(0, current + parseInt(q.getAttribute('data-dv-qty'), 10)));
        return;
      }
      if (e.target.closest('[data-dv-remove]') && li) { li.classList.add('is-leaving'); change(li.getAttribute('data-key'), 0); return; }
      var wb = e.target.closest('[data-dv-eng-watch]');
      if (wb) { eng.key = wb.getAttribute('data-dv-eng-watch'); renderEngrave(cart.items || []); return; }
      var pb = e.target.closest('[data-dv-eng-pos]');
      if (pb) { setPos(pb.getAttribute('data-dv-eng-pos')); return; }
      if (e.target.closest('[data-dv-eng-add]')) { addEngraving(); return; }
      var b = e.target.closest('[data-dv-bump]');
      if (b) { b.disabled = true; b.textContent = 'Adding'; add([{ id: parseInt(b.getAttribute('data-dv-bump'), 10), quantity: 1 }]).catch(function () { b.disabled = false; b.textContent = 'Add'; }); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-dv-eng-toggle]')) {
        var on = e.target.checked;
        $('[data-dv-eng-body]').hidden = !on;
        $('[data-dv-eng]').classList.toggle('is-open', on);
        if (on) { drawPreview(); setTimeout(function () { var i = root.querySelector('[data-dv-eng-f]:not([hidden]) input'); if (i) i.focus({ preventScroll: true }); $('[data-dv-eng]').scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60); }
      }
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-dv-eng-initial]')) { var v1 = clean(e.target.value, 'Crown'); e.target.value = v1; eng.initial = v1; drawPreview(); }
      if (e.target.matches('[data-dv-eng-name]')) { var v2 = clean(e.target.value, 'Caseback'); e.target.value = v2; eng.name = v2; count(); drawPreview(); }
    });
    root.addEventListener('focusin', function (e) { if (e.target.matches('[data-dv-eng-initial],[data-dv-eng-name]')) root.classList.add('is-typing'); });
    root.addEventListener('focusout', function (e) { if (e.target.matches('[data-dv-eng-initial],[data-dv-eng-name]')) setTimeout(function () { root.classList.remove('is-typing'); }, 150); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-dv-eng-initial],[data-dv-eng-name]')) { e.preventDefault(); addEngraving(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = [].filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea'), function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('dorven:cart:open', open);
    document.addEventListener('dorven:cart:refresh', refresh);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (root.closest('[id^="shopify-section"]') === e.target || e.target.contains(root)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    }
    refresh().catch(function () {});
  }

  window.DorvenCart = { open: function () { init(); open(); }, close: close, refresh: function () { init(); return refresh(); }, add: function (items) { init(); return add(items); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { if (root && !document.body.contains(root)) { root = null; } init(); });
})();
